import { Outlet, useRoute } from "@bcm-dev/bcms-vite";
import React, { useEffect } from 'react';
import PageContent from '../views/PageContent';
import "./styles.css";
/**
 * @function Home
 * @return {React.Component}
 * @exported true
 * @description The main component for Home
 */
export default function Home(props) {
  const navigate = useRoute();
  useEffect(() => {
   
  if(window.location.hash === "#/" || window.location.hash === "") { 
    navigate("/home/recenttransactions/" );
  }
}, []);
  return (
    <PageContent>
      <Outlet />
    </PageContent>
   )
}
